module.exports = __webpack_public_path__ + "images/menzis9a6de1ef303751bf4a3ef2c3f7f8780a.png";